import { useState } from "react";
import { Chakra } from "@airhelp/react-ui-components";
import chunk from "lodash.chunk";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { useReviews } from "contexts/DataContext";
import useDeviceSize from "hooks/useDeviceSize";
import ReviewCard from "./ReviewCard";
import { Dots } from "./Dots";

const { Box, Flex } = Chakra;

export const SliderDesktop = () => {
  const reviews = useReviews();
  const chunkedDesktopReviews = chunk(reviews, 3);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, instanceRef] = useKeenSlider({
    slides: { perView: 1, spacing: 32 },
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
  });

  const goToSlide = (slideIndex) => instanceRef.current?.moveToIdx(slideIndex);

  const desktopReviews = chunkedDesktopReviews?.map((reviewChunk) => (
    <Flex className="keen-slider__slide" key={`${reviewChunk[0].id}-${reviewChunk[1]?.id}`} pl={0}>
      {reviewChunk.map((review, index) => (
        <ReviewCard review={review} key={review.id} ml={index ? 8 : 0} mb={8} />
      ))}
    </Flex>
  ));

  return (
    <>
      <Box w={{ md: "calc(100vw - 2rem)", lg: "100%" }}>
        <Box ref={sliderRef} className="keen-slider">
          {desktopReviews}
        </Box>
      </Box>
      <Dots currentSlide={currentSlide} numberOfSlides={chunkedDesktopReviews.length} goToSlide={goToSlide} />
    </>
  );
};

export const SliderMobile = () => {
  const { isTablet } = useDeviceSize();

  const reviews = useReviews();
  const chunkedMobileReviews = isTablet ? chunk(reviews, 2) : chunk(reviews, 1);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, instanceRef] = useKeenSlider({
    slides: { perView: 1, spacing: 32 },
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
  });

  const goToSlide = (slideIndex) => instanceRef.current?.moveToIdx(slideIndex);

  const mobileReviews = chunkedMobileReviews?.map((reviewChunk) => (
    <Flex className="keen-slider__slide" key={`${reviewChunk[0].id}`} pl={{ base: 4, md: 0 }}>
      {reviewChunk.map((review, index) => (
        <ReviewCard review={review} key={review.id} ml={{ md: index ? 8 : 0 }} mb={{ base: 6, md: 8 }} />
      ))}
    </Flex>
  ));

  return (
    <>
      <Box w={{ base: "100vw", md: "calc(100vw - 2rem)" }}>
        <Box ref={sliderRef} className="keen-slider">
          {mobileReviews}
        </Box>
      </Box>
      <Dots currentSlide={currentSlide} numberOfSlides={chunkedMobileReviews.length} goToSlide={goToSlide} />
    </>
  );
};

export const ReviewSlider = () => {
  const { isDesktop } = useDeviceSize();
  return <>{isDesktop ? <SliderDesktop /> : <SliderMobile />}</>;
};
